
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import { Cliente } from '@/__env/lib/Clientes';
    import { PresetImportarExcel } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.nav';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import editar from './lista-buscador-presets-editar.vue';
    import { IColumna } from '@/__env/lib/Ventas/ImportarExcel/Presets/Preset.lib';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto )
                this.Buscar();
        }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }



        public Cargando: boolean = false;
        public Seleccionada: PresetImportarExcel = null;
        public ColumnasNueva: IColumna[] = [];
        public Items: PresetImportarExcel[] = [];



        public Busqueda: string = '';
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            let bb = this.Busqueda;
            await Wait( 600 );
            if ( bb == this.Busqueda )
            {
                if ( !this.Items.hasRows() )
                    this.Buscar();
            }
        }

        async Buscar( forzar?: boolean )
        {
            if ( forzar )
            {
                this.Busqueda = '';
            }

            this.Items.clear();
            this.Cargando = true;
            let ff: any = {

            };
            if ( this.Busqueda )
                ff.q = this.Busqueda;
            let e = await PresetImportarExcel.find( ff );
            if ( e.Items.hasRows() )
            {
                this.Items = e.Items;
            }
            this.Cargando = false;
        }

        async Utilizar( x: PresetImportarExcel )
        {
            this.Seleccionada = x;
            this.Controlador.UsarPreset( x );
            this.Cerrar();
        }


        ObtenerPreset(): IColumna[]
        {
            if ( this.Controlador.Preset )
            {
                let p = new PresetImportarExcel();
                for ( let o of Object.keys( this.Controlador.Preset ) )
                {
                    let c = new IColumna();
                    c.Columna = parseInt( o );
                    c.Tipo = this.Controlador.Preset[parseInt( o )];
                    p.Columnas.push( c );
                }

                return p.Columnas;
            }
            return [];
        }

        async Guardar()
        {
            let preset = this.ObtenerPreset();
            if ( !preset.hasRows() )
            {
                Utiles.Notificaciones.Error( 'El preset no tiene columnas!' );
                return;
            }

            if ( await Utiles.Mensajes.SiNo( 'Guardar preset', `¿Guardar el preset ${this.Seleccionada.Nombre}? Lo reemplazaras por la configuración actual` ) )
            {
                if ( this.Seleccionada && this.Seleccionada.Existe )
                {
                    this.Seleccionada.Columnas = preset;
                    let e = await this.Seleccionada.save();
                    if ( e )
                    {
                        Utiles.Notificaciones.Completado( 'Guardado correctamente!' );
                        this.Recargar();
                    } else
                    {
                        Utiles.Notificaciones.Error( 'Error al guardar' );
                    }
                }
            }
        }

        public Editando: boolean = false;
        async GuardarComo()
        {
            let preset = this.ObtenerPreset();
            if ( !preset.hasRows() )
            {
                Utiles.Notificaciones.Error( 'El preset no tiene columnas!' );
                return;
            }

            this.ColumnasNueva = preset;
            this.Editando = true;
        }


        async Eliminar( x: PresetImportarExcel )
        {
            if ( await Utiles.Mensajes.SiNo( 'Eliminar preset', '¿Eliminar este preset?' ) )
            {
                let e = await x.del();
                if ( e )
                {
                    Utiles.Notificaciones.Completado( 'Eliminado correctamente!' );
                    this.Recargar();
                } else
                {
                    Utiles.Notificaciones.Error( 'Error al Eliminar' );
                }
            }
        }



        async Recargar()
        {
            this.Editando = false;
            this.Busqueda = '';
            await this.Buscar();
        }


        Cerrar()
        {
            this.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
